export enum DistributionDirection {
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL',
}

export const DISTRIBUTION_MIN_ELEMENTS = 3;
